// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { colors, fontSizes, layout, fontFamily, shadows } from '@/theme';
import Button from '@/components/button';
import Breadcrumbs from '@/components/breadcrumbs';
import Search from '@/components/search';
import Table from '@/components/table';

import CellStatus from '@/components/cells/status-old';
import CellDate from '@/components/cells/date';
import CellBold from '@/components/cells/bold';
import CellTech from '@/components/cells/tech';
import CellCheckbox from '@/components/cells/checkbox';

import KendoPager from '@/components/kendo/kendo-pager';
import KendoTable from '@/components/kendo/kendo-table';
import KendoCellStatus from '@/components/kendo/cells/kendo-cell-status';
import KendoCellEmployee from '@/components/kendo/cells/kendo-cell-employee';
import KendoCellDate from '@/components/kendo/cells/kendo-cell-date';
import KendoCellBool from '@/components/kendo/cells/kendo-cell-bool';

import Router, {useRouter} from 'next/router';
import Fetch from '@/utils/Fetch';
import * as Enums from '@/utils/enums';
import SettingsMenu from '@/components/settings/menu';
import Storage from '@/utils/storage';
import Helper from '@/utils/helper';
// filtersConfig code
import UCS from '@/services/option/user-config-service';
import SettingsMessageTemplateList from "@/PageComponents/Table/Component Tables/SettingsMessageTemplateList";
import {Flex} from "@mantine/core";
import { createFileRoute } from '@tanstack/react-router'


// filtersConfig code

function TemplateList(props: any) {

  const router = useRouter()

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  useEffect(() => {
    getAccessStatus();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(router.replace, "/");
    }
  }, [accessStatus]);

  return (
    <div className="settings-container">
      <Flex>
        <SettingsMenu urlPath={router.asPath} />
        <div className="settings-card">
          <SettingsMessageTemplateList />
        </div>
      </Flex>
    </div>
  );
}


export default TemplateList;

export const Route = createFileRoute('/_authenticated/settings/template/list')({ component: TemplateList })
